export default "__VITE_ASSET__wlkzlQ09__"